export const EventType = {
  PAYMENT_STATUS: 'PAYMENT_STATUS',
  ON_CLOSE: 'ON_CLOSE',
  ON_ERROR: 'ON_ERROR',
  CHARGE_EXPIRED: 'CHARGE_EXPIRED',
  CHARGE_COMPLETED: 'CHARGE_COMPLETED',
  CASHBACK_APPLY: 'CASHBACK_APPLY',
  CASHBACK_COMPLETE: 'CASHBACK_COMPLETE',
  CASHBACK_INACTIVE: 'CASHBACK_INACTIVE',
  PAY_AS_GUEST: 'PAY_AS_GUEST',
};
